/* Copy da criação de plano público em página cheia (ADR-0704). "Capabilities" fica sem tradução
   nos dois idiomas — é o termo técnico já usado assim em todo o domínio de planos. */
import type { Bilingual } from '../bilingual.js';
import { useBilingual } from '../locale-provider.js';

interface PlanCreateContent {
  readonly breadcrumbAriaLabel: string;
  readonly breadcrumbPlans: string;
  readonly breadcrumbNewPlan: string;
  readonly pageTitle: string;
  readonly forbiddenMessage: string;
  readonly pageDescription: string;
  readonly identityCardTitle: string;
  readonly identityCardDescription: string;
  readonly pricingCardTitle: string;
  readonly pricingCardDescription: string;
  readonly capabilitiesCardTitle: string;
  readonly capabilitiesCardDescription: string;
  readonly cancelButton: string;
  readonly createButton: string;
  readonly createSuccessToast: string;
}

const PLAN_CREATE_CONTENT: Bilingual<PlanCreateContent> = {
  'pt-BR': {
    breadcrumbAriaLabel: 'Trilha',
    breadcrumbPlans: 'Planos',
    breadcrumbNewPlan: 'Novo plano',
    pageTitle: 'Novo plano',
    forbiddenMessage: 'Você não tem permissão para criar planos.',
    pageDescription:
      'Cria o Product + Price no Stripe e registra o plano no catálogo. Preço 0 = plano ' +
      'só-capabilities (sem cobrança).',
    identityCardTitle: 'Identidade',
    identityCardDescription:
      'Tier, ordenação, lookup key e nome. Lookup key e nome são imutáveis após criar.',
    pricingCardTitle: 'Preço',
    pricingCardDescription: 'Preço, intervalo de cobrança e visibilidade nas listagens do app.',
    capabilitiesCardTitle: 'Capabilities',
    capabilitiesCardDescription:
      'O que o plano concede. Ausência da chave = não concedida (default-deny).',
    cancelButton: 'Cancelar',
    createButton: 'Criar plano',
    createSuccessToast: 'Plano criado (Product + Price no Stripe).',
  },
  'en-US': {
    breadcrumbAriaLabel: 'Breadcrumb',
    breadcrumbPlans: 'Plans',
    breadcrumbNewPlan: 'New plan',
    pageTitle: 'New plan',
    forbiddenMessage: 'You do not have permission to create plans.',
    pageDescription:
      'Creates the Product + Price in Stripe and registers the plan in the catalog. Price 0 = ' +
      'capabilities-only plan (no billing).',
    identityCardTitle: 'Identity',
    identityCardDescription:
      'Tier, ordering, lookup key, and name. Lookup key and name are immutable after creation.',
    pricingCardTitle: 'Pricing',
    pricingCardDescription: 'Price, billing interval, and visibility in the app listings.',
    capabilitiesCardTitle: 'Capabilities',
    capabilitiesCardDescription: 'What the plan grants. Missing key = not granted (default-deny).',
    cancelButton: 'Cancel',
    createButton: 'Create plan',
    createSuccessToast: 'Plan created (Product + Price in Stripe).',
  },
};

export const usePlanCreateContent = (): PlanCreateContent => useBilingual(PLAN_CREATE_CONTENT);
